import { Link } from "react-router-dom";
import { categoryNav } from "@/mocks/home";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 -mt-10 relative z-20">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {categoryNav.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${cat.color} text-background-50 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}